import {
  ShieldCheck,
  Ticket,
  Globe,
  Clock,
  Umbrella,
  Suitcase,
  Shuffle,
  ForkKnife,
  ChatText,
  Headset,
  DeviceMobile,
  AirplaneTilt,
  Timer,
} from '@phosphor-icons/react';

import {
  AIR_HELP,
  ALL_INCLUSIVE_PROTECTION,
  BAGGAGE_SERVICE,
  BANKRUPTCY_INSURANCE_COVER_GENIUS,
  CABIN_BAGGAGE,
  CANCEL_FOR_ANY_REASON,
  CANCELLATION_GUARANTEE,
  CANCELLATION_INSIDE_EU,
  CANCELLATION_INSURANCE_COVER_GENIUS,
  CANCELLATION_OUTSIDE_EU,
  CANCEL_24_HOURS,
  CHECK_IN_BAGGAGE,
  CO2_COMPENSATION,
  COMPREHENSIVE_INSURANCE_COVER_GENIUS,
  FLEXIBLE_TICKET,
  MEAL,
  MOBILE_TRAVEL_PLAN,
  ONLINE_CHECK_IN,
  PLATINUM_SERVICE,
  SEAT_MAP,
  SIMPLE_VISA,
  SMS,
  TRAVEL_INSURANCE_COVER_GENIUS,
  TRAVEL_INSURANCE_INSIDE_EU,
  TRAVEL_INSURANCE_OUTSIDE_EU,
  TRIP_CANCELLATION_PROTECTION,
  FAST_TRACK,
} from '@eti/products';
import { vars } from '@etg/wings';
import type { IconProps } from '@eti/components';
import { Icon } from '@eti/components';
import { css } from '@eti/styles';

const iconStyle = css`
  color: ${vars.colors.decoration.dark};
  stroke: ${vars.colors.decoration.dark};
`;

type CustomIconProps = IconProps & { 'data-testid': string };

const CustomIcon = ({ id, size, 'data-testid': dataTestId }: CustomIconProps) => (
  <Icon className={iconStyle} data-testid={dataTestId} id={id} size={size} />
);

const productIconMap = {
  [AIR_HELP.name]: Clock,
  [ALL_INCLUSIVE_PROTECTION.name]: Umbrella,
  [BAGGAGE_SERVICE.name]: Suitcase,
  [BANKRUPTCY_INSURANCE_COVER_GENIUS.name]: Umbrella,
  [CABIN_BAGGAGE.name]: Suitcase,
  [CANCEL_FOR_ANY_REASON.name]: ShieldCheck,
  [CANCELLATION_GUARANTEE.name]: ShieldCheck,
  [CANCELLATION_INSIDE_EU.name]: ShieldCheck,
  [CANCELLATION_INSURANCE_COVER_GENIUS.name]: ShieldCheck,
  [CANCELLATION_OUTSIDE_EU.name]: ShieldCheck,
  [CHECK_IN_BAGGAGE.name]: Suitcase,
  [COMPREHENSIVE_INSURANCE_COVER_GENIUS.name]: Umbrella,
  [CANCEL_24_HOURS.name]: ShieldCheck,
  [CO2_COMPENSATION.name]: (props: CustomIconProps) => (
    <CustomIcon id="co2-compensation" {...props} />
  ),
  [FLEXIBLE_TICKET.name]: Shuffle,
  [MEAL.name]: ForkKnife,
  [MOBILE_TRAVEL_PLAN.name]: ChatText,
  [ONLINE_CHECK_IN.name]: Ticket,
  [PLATINUM_SERVICE.name]: Headset,
  [SEAT_MAP.name]: (props: CustomIconProps) => <CustomIcon id="seat-thin" {...props} />,
  [SIMPLE_VISA.name]: Globe,
  [SMS.name]: DeviceMobile,
  [TRAVEL_INSURANCE_COVER_GENIUS.name]: Umbrella,
  [TRAVEL_INSURANCE_INSIDE_EU.name]: Umbrella,
  [TRAVEL_INSURANCE_OUTSIDE_EU.name]: Umbrella,
  [TRIP_CANCELLATION_PROTECTION.name]: ShieldCheck,
  [FAST_TRACK.name as string]: Timer,
};

const ProductIcon = ({ productName, isRTL }: { productName: string; isRTL: boolean }) => {
  const IconComponent = productIconMap[productName] || AirplaneTilt;

  return (
    <IconComponent
      aria-hidden="true"
      color={vars.colors.decoration.dark}
      data-testid={`${productName}-icon`}
      mirrored={isRTL}
      size="1.5rem"
    />
  );
};

export default ProductIcon;
